var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-proposal"},[_c('NavBar',{attrs:{"active-menu":"proposal"}}),_c('SearchProposal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }